import { Divider, notification, Tag } from "antd";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import TextArea from "antd/lib/input/TextArea";
import Modal from "antd/lib/modal/Modal";
import { observer } from "mobx-react";
import moment from "moment";
import MainStore from "../../home/store/mainStore";
import React, { createContext, useContext } from "react";
import { useState } from "react";
import _ from "underscore";
import RequestStore from "../approvals/store/requeststore";
import { toJS } from "mobx";
import { getCurrentUser } from "../../../Utility/modules/helpers";
const mainStorectx = createContext(MainStore);
const requestStoreCtx = createContext(RequestStore);
export const DeclineDialog = observer(() => {
  const requestStore = useContext(requestStoreCtx);
  const mainStore = useContext(mainStorectx);
  const [reason, setReason] = useState("");
  return (
    <Modal
      visible={requestStore.showDeclineDialog}
      okText="Decline Request"
      title="Decline Request"
      okButtonProps={{
        disabled: _.isEmpty(reason),
        loading: requestStore.isLoading,
      }}
      onCancel={() => {
        requestStore.showDeclineDialog = false;
      }}
      onOk={async () => {
        try {
          console.log(
            "sel items",
            toJS(requestStore.selAppItems),
            mainStore.assetContextId
          );

          const req = await requestStore.declineRequest(
            toJS(requestStore.selAppItems),
            reason,
            mainStore.assetContextId
          );

          requestStore.showDeclineDialog = false;
          requestStore.selAppItems = [];
          await requestStore.loadMyApprovals(getCurrentUser()?.id);
          notification.success({
            message: "SPARS Feedback",
            description: `request declined successfully with notifications sent`,
          });
        } catch (error) {
          notification.error({
            message: "SPARS Feedback",
            description: error.message,
          });
        }
      }}
    >
      <Form layout="vertical">
        <FormItem label="Asset:">
          <span style={{ fontWeight: "bold" }}>
            {mainStore.assetContextName}
          </span>
        </FormItem>
        {requestStore.selAppItems.length > 1 && (
          <>
            <Divider>Decline for:</Divider>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <span style={{ color: "red", fontWeight: "bold" }}>
                    {requestStore.selAppItems.length}
                  </span>{" "}
                  Producing Day
                  {requestStore.selAppItems.length > 1 ? "s" : ""}
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  {requestStore.selAppItems.map((d) => (
                    <Tag key={d.productionDate}>
                      {moment(d.productionDate).format("dddd MMM Do YYYY")}
                    </Tag>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
        {/* {requestStore.selAppItems.length === 1 && (<FormItem label="Production(Refer) Date:">
          <b>
            {moment(requestStore.selAppItems.productionDate).format(
              "Do dddd, MMMM YYYY"
            )}
          </b>
        </FormItem>)} */}

        {requestStore.selAppItems.length === 1 && (
          <FormItem label="Production(Refer) Date:">
            <b>
              {moment(requestStore.selAppItems[0].productionDate).format(
                "Do dddd, MMMM YYYY"
              )}
            </b>
          </FormItem>
        )}
        <br />
        <FormItem label="Decline Reason:" labelAlign="top">
          <TextArea
            onChange={({ target }) => {
              setReason(target.value);
            }}
            rows={10}
          ></TextArea>
        </FormItem>
      </Form>
    </Modal>
  );
});

